import {DomUtils} from "./domutils.mjs";

class DocProviderInterface{
    constructor(document){
        var _doc = document;

        Object.defineProperty(this,'getDocument',{
            value : function(){ return _doc }
        });
    }
}

export class DocProviderParts extends DocProviderInterface{
    constructor(createBodyNodes, createHeadNodes, context){
        var bodyNodes = (createBodyNodes) ? createBodyNodes.call(undefined, context) : undefined; /* modified 20-05-2021 */
        var headNodes = (createHeadNodes) ? createHeadNodes() : undefined;
        var doc = DomUtils.createDocument(bodyNodes, headNodes);
        super(doc);
    }
}

export class DocProviderLayout extends DocProviderInterface{
    constructor(layout, context){
        var doc = DocProviderLayout.createDoc(layout, context);
        super(doc); 
    }

    // ======
    // static
    // ------
    static createDoc(template, context){
        var str = DocProviderLayout.render(template, context) || '';
        var doc = DocProviderLayout.strToDocument(str);
        return doc;   
    }

    static render(template, context){  
        var str;
        if (template) str = template.render(context);
        return str;
    }

    static strToDocument(str){
        var parser = new DOMParser();
        var document = parser.parseFromString(str,'text/html');
        return document;
    }
}

export class PartsOptions{
    constructor(createBodyNodes, createHeadNodes, context){
        var _createBodyNodes = createBodyNodes;
        var _createHeadNodes = createHeadNodes;
        var _context = context;

        Object.defineProperty(this,'createBodyNodes',{
            value : _createBodyNodes
        });   

        Object.defineProperty(this,'createHeadNodes',{
            value :_createHeadNodes
        });  

        Object.defineProperty(this,'getContext',{
            value : ()=>_context
        });

        Object.defineProperty(this,'setContext',{
            value : (context)=>{ _context = context }
        })
    }
}


export class LayoutOptions{
    constructor(layout,context){
        this.layout = layout;
        this.context = context; 
    }
    getLayout(){ return this.layout }
    getContext(){ return this.context }
    setContext(context){ this.context = context }
}

/**
 * Function that return a docProvider (DocProviderParts or DocProviderLayout) from the type of the option
 * Ex: option = PartsOptions >> returns DocProviderParts 
 * option = LayoutOptions >> returns DocProviderLayout  
 */
export class DocProviderProvider{
    constructor(options){}


    static get(options){
        if (options instanceof PartsOptions) return new DocProviderParts(options.createBodyNodes, options.createHeadNodes, options.getContext());
        if (options instanceof LayoutOptions) return new DocProviderLayout(options.getLayout(), options.getContext());    
    }
}
 
/**
 * docProviderPartsOptions interface
 * --------------------------
 * createBodyNodes - function that returns a nodeList 
 * createHeadNodes - (optional)
 * context - (optional) context used to call createBodyNodes 
 */

/**
 * DocProviderLayoutOptions Interface
 * ----------------------------------
 * getLayout - function that returns the layout 
 * getContext 
 */
